import { render, staticRenderFns } from "./WorkspaceDetails.vue?vue&type=template&id=eaed6f78&scoped=true"
import script from "./WorkspaceDetails.vue?vue&type=script&lang=js"
export * from "./WorkspaceDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceDetails.vue?vue&type=style&index=0&id=eaed6f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaed6f78",
  null
  
)

export default component.exports